namespace $ {
	$mol_style_define( $mol_frame , {
		border: {
			style: 'none',
		},
		maxHeight: $mol_style_unit.vh(100),
	} )
}
